import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Renders an assistant reply's markdown (headings, lists, tables, bold, code) with the app's styling.
// react-markdown does not render raw HTML, so model output can't inject markup.
const C = {
  h1: (p) => <h1 className="text-base font-semibold text-slate-800 mt-3 mb-1.5 first:mt-0" {...p} />,
  h2: (p) => <h2 className="text-[15px] font-semibold text-slate-800 mt-3 mb-1.5 first:mt-0" {...p} />,
  h3: (p) => <h3 className="text-sm font-semibold text-slate-800 mt-2.5 mb-1 first:mt-0" {...p} />,
  h4: (p) => <h4 className="text-[13px] font-semibold text-slate-700 mt-2 mb-1 first:mt-0" {...p} />,
  p: (p) => <p className="mb-2 last:mb-0" {...p} />,
  ul: (p) => <ul className="list-disc pl-5 mb-2 space-y-0.5" {...p} />,
  ol: (p) => <ol className="list-decimal pl-5 mb-2 space-y-0.5" {...p} />,
  li: (p) => <li className="pl-0.5" {...p} />,
  strong: (p) => <strong className="font-semibold text-slate-800" {...p} />,
  em: (p) => <em className="italic" {...p} />,
  hr: () => <hr className="my-3 border-slate-200" />,
  blockquote: (p) => <blockquote className="border-l-2 border-slate-300 pl-3 my-2 text-slate-500" {...p} />,
  a: (p) => <a className="text-sky-700 underline" target="_blank" rel="noreferrer" {...p} />,
  code: ({ inline, className, children, ...p }) => (
    className
      ? <code className="block text-[11px] bg-slate-100 rounded p-2 my-2 overflow-auto whitespace-pre" {...p}>{children}</code>
      : <code className="text-[12px] bg-slate-100 text-slate-700 rounded px-1 py-0.5" {...p}>{children}</code>
  ),
  pre: (p) => <pre className="my-0" {...p} />,
  table: (p) => <div className="overflow-auto my-2"><table className="w-full border-collapse text-xs" {...p} /></div>,
  th: (p) => <th className="border border-slate-300 bg-slate-50 px-2 py-1 text-left font-semibold" {...p} />,
  td: (p) => <td className="border border-slate-200 px-2 py-1 align-top" {...p} />,
};

export function ChatMarkdown({ children }) {
  return <ReactMarkdown remarkPlugins={[remarkGfm]} components={C}>{children || ""}</ReactMarkdown>;
}
